import { render, staticRenderFns } from "./NotWechat.vue?vue&type=template&id=b1c93a4c&scoped=true"
import script from "./NotWechat.vue?vue&type=script&lang=js"
export * from "./NotWechat.vue?vue&type=script&lang=js"
import style0 from "./NotWechat.vue?vue&type=style&index=0&id=b1c93a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c93a4c",
  null
  
)

export default component.exports